import { useQuery } from "@tanstack/react-query";

import { reviewKeys } from "@/application/query-keys/review-keys";
import { reviewTicketsRepository } from "@/infrastructure/repositories/review-tickets-supabase-repository";

/** The review ticket for one block-v board item, by its BF code. */
export function useReviewTicketByBoardCode(boardCode: string | null) {
  return useQuery({
    queryKey: reviewKeys.ticketByBoard(boardCode ?? ""),
    queryFn: () => reviewTicketsRepository.getByBoardCode(boardCode as string),
    enabled: Boolean(boardCode),
    staleTime: 30 * 1000,
  });
}
